import { render } from "./WebShow.vue?vue&type=template&id=0aeb0932"
import script from "./WebShow.vue?vue&type=script&lang=js"
export * from "./WebShow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__